// extracted by mini-css-extract-plugin
module.exports = {"halfMarginTransform":"Sidebar_halfMarginTransform__2yamW","marginTransform":"Sidebar_marginTransform__3KMM9"};